
const WelcomeSection = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-xs text-gray-500 uppercase tracking-wider mb-5">(Welcome)</p>
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1B3A52] mb-8 leading-tight">
          A Heart for Ministry
        </h2>
        <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-6">
          Welcome to a place where faith meets the written word. For over three decades, Pastor Don R. Vining has dedicated his life to shepherding God's people and sharing the transformative power of Scripture. Through his books, he invites you on a journey of spiritual discovery, offering biblical wisdom, practical guidance, and heartfelt encouragement for every season of life.
        </p>
        <p className="text-lg font-bold text-[#1B3A52]">
          — Pastor Don R Vining
        </p>
      </div>
    </section>
  );
};

export default WelcomeSection;
